var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDismissMedium = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.94 12L6 7.06A.75.75 0 017.06 6L12 10.94 16.94 6A.75.75 0 1118 7.06L13.06 12 18 16.94A.75.75 0 0116.94 18L12 13.06 7.06 18A.75.75 0 116 16.94L10.94 12z"
  })));
});
export default SvgDismissMedium;